import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for casino report view.
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable for displaying casino report details.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // DataTable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'TransactionId',
                    header: _('Transacción ID'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                {
                    id: 'Amount',
                    header: _('Valor'), // Localized header
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for the column
                    sort: 'int',
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager configuration
            // API endpoint for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReportDetail',
        };
    }

    /**
     * Initializes event listeners for the grid.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        // Event listener for filtering casino reports
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1, // Load grid data with filters
            );
        });

        // Event listener for user ID changes
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(grid.data.url + '?id=' + idUser); // Load grid data for specific user
        });

        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
